import React from 'react'

export const Footer = () => {
  return (
    <footer className="footer">
        Portafolio &copy; Dev N Design - 2024
    </footer>
  )
}
